import { Skeleton } from '@/components/ui/skeleton';

export default function NavigationBarSkeleton() {
  return (
    <div className="fixed z-50 bottom-0 shadow-xl shadow-black/50 w-full bg-sivarbet-background border-t border-sivarbet-border text-sivarbet-text flex justify-around items-end py-2 px-4 md:hidden mt-1 pb-4">
      {/* Home item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-6 w-6 rounded-full mb-1" />
        <Skeleton className="h-3 w-12 rounded-md" />
      </div>

      {/* Casino item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-6 w-6 rounded-full mb-1" />
        <Skeleton className="h-3 w-12 rounded-md" />
      </div>

      {/* Deportes item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-6 w-6 rounded-full mb-1" />
        <Skeleton className="h-3 w-12 rounded-md" />
      </div>

      {/* Discover item skeleton */}
      <div className="flex flex-col items-center">
        <Skeleton className="h-6 w-6 rounded-full mb-1" />
        <Skeleton className="h-3 w-12 rounded-md" />
      </div>
    </div>
  )
}
